import React from "react";
function JSCheckOutInternational() {
  return (
    <div class="idocs-content">
      <div class="container">
        <div class="row">
          <div class="col-md-8">
            <section id="idocs_content" class="mt-20 mb-20">
              <h2> JS Checkout</h2>
              <hr />
            </section>
            <p>
              JS Checkout is an easy setup for businesses to collect payment on
              their platform without coding experience. <b>Safexpay</b> will
              provide you with a few lines of code snippets, which you must
              integrate into your website code. This will enable you to use the{" "}
              <b>Safexpay</b> JS Checkout feature and start accepting payments
              within an hour.
            </p>
            <p>
              It is a pop-up payment flow where the customers will remain on
              merchant websites and hence will add customer satisfaction. This
              will enhance the trust and confidence of the customer to proceed
              with the checkout process and pay with their preferred payment
              method.
            </p>
            {/*  JS Checkout flow video: strat */}
            {/* <div className="js-check-div">
              <img src="assets/images/InternationalCheckoutJS.png" alt="image" width="100%" />
            </div> */}
            {/* <div className="demo-img">
              <img
                src="#"
                alt="image-pending"
                width="100px"
                className="demo-style"
              />
            </div> */}
            {/*  JS Checkout flow video. end */}
            <section id="idocs_content" class="mt-20 mb-20">
              <h3>Safexpay Test Environments for JS CHECKOUT</h3>
              <hr />
            </section>
            <table class="table table-bordered">
              <tbody className="table-bdy">
                <tr>
                  <td className="table-color">Post URL</td>
                  <td>
                    {/* <a href="https://uatcheckout.safexpay.ae/ms-transaction-core-1-0/paymentRedirection/checksumGatewayPage">
                      https://uatcheckout.safexpay.ae/ms-transaction-core-1-0/paymentRedirection/checksumGatewayPage
                    </a> */}
                    <span>
                      https://uatcheckout.safexpay.ae/ms-transaction-core-1-0/paymentRedirection/checksumGatewayPage
                    </span>
                  </td>
                </tr>
                <tr>
                  <td className="table-color">Merchant ID</td>
                  <td>202402150001</td>
                </tr>
                <tr>
                  <td className="table-color">Encryption Key</td>
                  <td>lC7IcC3/wiqxs3wN0ksW0JLAxdnR8NhRm42k7LIofQk=</td>
                </tr>
                <tr>
                  <td className="table-color">Aggregator ID</td>
                  <td> paygate</td>
                </tr>
              </tbody>
            </table>
            <h4>
              Integrate Safexpay JS Checkout using the simple steps below:
            </h4>
            <ul>
              <li>
                <p>Get Onboarded on the Safexpay platform as a merchant. </p>
              </li>
              <li>
                <p>
                  Save the MID and key received after successful onboarding.
                </p>
              </li>
              <li>
                <p>Choose for JS checkout integration. </p>
              </li>
              <li>
                <p>
                  Safexpay will provide a JS Checkout code snippet to paste into
                  your website code.
                </p>
              </li>
              <li>
                <p>
                  The customer loads the cart with the product he wants to buy,
                  and the merchant invokes the JS pop-up at their backend and
                  creates an order to call Safexpay Transaction API.
                </p>
              </li>
              <li>
                <p>JS module renders the checkout page on the browser. </p>
              </li>
              <li>
                <p>Users select their preferred payment method. </p>
              </li>
              <li>
                <p>
                  The customer fills in the payment details and is taken to the
                  bank page for authorization.
                </p>
              </li>
              <li>
                <p>Your customers can now pay without any redirection! </p>
              </li>
            </ul>
            <h4>Steps to Integrate JS Checkout :</h4>
            <p className="para-blod">Step - 1</p>
            <p>Below scripts to be included at top of the page in head tag.</p>
            <div class="form-data1 mb-3">
              <pre style={{ fontSize: "15px" }}>
                <span class="token operator">&lt;</span>script src
                <span class="token operator">=</span>
                <span class="token string">
                  "https://uatcheckout.safexpay.ae/ms-transaction-core-1-0/jscheckout/js-checkoutNew.js"
                </span>
                <span class="token operator">&gt;</span>
                <span class="token operator">&lt;</span>
                <span class="token operator">/</span>script
                <span class="token operator">&gt;</span>
                {"\n"}
                <span class="token operator">&lt;</span>script src
                <span class="token operator">=</span>
                <span class="token string">
                  "https://ajax.googleapis.com/ajax/libs/jquery/3.6.0/jquery.min.js"
                </span>{" "}
                type<span class="token operator">=</span>
                <span class="token string">"text/javascript"</span>
                <span class="token operator">&gt;</span>
                <span class="token operator">&lt;</span>
                <span class="token operator">/</span>script
                <span class="token operator">&gt;</span>
                {"\n"}
                <span class="token operator">&lt;</span>script type
                <span class="token operator">=</span>
                <span class="token string">"text/javascript"</span> src
                <span class="token operator">=</span>
                <span class="token string">"crypto-js.js"</span>
                <span class="token operator">&gt;</span>
                <span class="token operator">&lt;</span>
                <span class="token operator">/</span>script
                <span class="token operator">&gt;</span>
                {"\n"}
                <span class="token operator">&lt;</span>script type
                <span class="token operator">=</span>
                <span class="token string">"text/javascript"</span> src
                <span class="token operator">=</span>
                <span class="token string">"integration.js"</span>
                <span class="token operator">&gt;</span>
                <span class="token operator">&lt;</span>
                <span class="token operator">/</span>script
                <span class="token operator">&gt;</span>
              </pre>
            </div>
            <p className="para-blod">Step - 2</p>
            <p>
              Create JSON "Object" for below parameters, which would be
              containing Key-Value pairs.
            </p>
            <table class="table table-bordered">
              <tbody>
                <tr>
                  <th className="table-color">Items</th>
                  <th className="table-color">Abbreviation</th>
                </tr>
                <tr className="table-center-txt">
                  <td>txnDetails</td>
                  <td>Contains Order details</td>
                </tr>
                <tr className="table-center-txt">
                  <td>customerDetails</td>
                  <td>Contains Customer info</td>
                </tr>
                <tr className="table-center-txt">
                  <td>billingDetails</td>
                  <td>Contains Billing address</td>
                </tr>
                <tr className="table-center-txt">
                  <td>shipDetails</td>
                  <td>Contains Shipping address</td>
                </tr>
                <tr className="table-center-txt">
                  <td>itemDetails</td>
                  <td>Contains Product details</td>
                </tr>
                <tr className="table-center-txt">
                  <td>otherDetails</td>
                  <td>Contains additional info</td>
                </tr>
              </tbody>
            </table>
            <div className="form-data1 mb-3">
              <pre id="json">
                {"\u007B"}
                {"\n"}
                "txnDetails": {"\u007B"}
                {"\n"}
                "orderNo": 2599,{"\n"}
                "amount": "1",{"\n"}
                "countryCode": "ARE",{"\n"}
                "currencyCode": "AED",{"\n"}
                "txnType": "SALE",{"\n"}
                "channel": "WEB",{"\n"}
                "userId": "custemail@hotmail.com"{"\n"}
                {"\u007D"},{"\n"}
                "customerDetails": {"\u007B"}
                {"\n"}
                "name": "sagar",{"\n"}
                "email": "xyzp@compny.com",{"\n"}
                "phone": "1767440987"{"\n"}
                {"\u007D"},{"\n"}
                "billingDetails": {"\u007B"}
                {"\n"}
                "bill_address": "123",{"\n"}
                "bill_city": "Gurgaon",{"\n"}
                "bill_state": "Hariyana",{"\n"}
                "bill_country": "India",{"\n"}
                "bill_zip": "110038"{"\n"}
                {"\u007D"},{"\n"}
                "shipDetails": {"\u007B"}
                {"\n"}
                "ship_address": "",{"\n"}
                "ship_city": "",{"\n"}
                "ship_state": "",{"\n"}
                "ship_country": "",{"\n"}
                "ship_zip": "",{"\n"}
                "ship_days": "",{"\n"}
                "address_count": ""{"\n"}
                {"\u007D"},{"\n"}
                "itemDetails":{"\u007B"}
                {"\n"}
                "item_count": "",{"\n"}
                "item_value": "",{"\n"}
                "item_category": ""{"\n"}
                {"\u007D"},{"\n"}
                "otherDetails": {"\u007B"}
                {"\n"}
                "udf_1": "",{"\n"}
                "udf_2": "",{"\n"}
                "udf_3": "",{"\n"}
                "udf_4": "",{"\n"}
                "udf_5": ""{"\n"}
                {"\u007D"}
                {"\n"}
                {"\u007D"}
                {"\n"}
              </pre>
            </div>
            <p className="para-blod">Step - 3</p>
            <p>
              Encrypt the created JSON object, using Merchant Key with AES 256
              algorithm.
            </p>
            <p className="para-blod">Sample encrypted data :</p>
            <p>CSmRIwyPLdfr3NkHqPvPCv1dzZz8c9h40Mmd.....DATA TRIMMED.!!!</p>
            <p className="para-blod">Step - 4</p>
            Create HASH using SHA-512 algorithm, below combination of components
            to be used to create HASH.
            <p className="para-blod">Example :</p>
            meId|orderNo|amount|countryCode|currencyCode Plain text:
            202308230004|3990|1|ARE|AED HASHED data:
            e424c7dfa84ee9179ca402897cc413fe774c8bf3.....DATA TRIMMED.!!!
            <p className="para-blod">Step - 5</p>
            Add below code snippet within your checkout page…
            <div className="form-data1">
              <pre>
                <span class="token operator">&lt;</span>script
                <span class="token operator">&gt;</span>
                let jsCheckoutOptions <span class="token operator">=</span>{" "}
                <span class="token punctuation">{"\u007B"}</span>merchantId
                <span class="token punctuation">:</span>{" "}
                <span class="token string">"999990300010"</span>{" "}
                <span class="token operator">&lt;</span>
                <span class="token operator">&lt;</span>
                <span class="token operator">&lt;</span> Merchant ID{" "}
                <span class="token punctuation">{"\u007D"}</span>
                {"\n"}
                let spObj <span class="token operator">=</span>{" "}
                <span class="token keyword">new</span>{" "}
                <span class="token class-name">JsCheckout</span>
                <span class="token punctuation">(</span>
                <span class="token punctuation">)</span>
                <span class="token punctuation">;</span>{" "}
                <span class="token comment">
                  // Creating object of JS Checkout Library.
                </span>
                {"\n"}
                spObj<span class="token punctuation">.</span>
                <span class="token function">Init</span>
                <span class="token punctuation">(</span>jsCheckoutOptions
                <span class="token punctuation">)</span>
                <span class="token punctuation">;</span>{" "}
                <span class="token comment">
                  // Initializing the required options.
                </span>
                {"\n"}
                Buy <span class="token operator">=</span>{" "}
                <span class="token keyword">function</span>
                <span class="token punctuation">(</span>
                <span class="token punctuation">)</span>{" "}
                <span class="token punctuation">{"\u007B"}</span>spObj
                <span class="token punctuation">.</span>
                <span class="token function">Pay</span>
                <span class="token punctuation">(</span>
                <span class="token string">'encryptedData'</span>
                <span class="token punctuation">,</span>
                <span class="token string">'hash'</span>
                <span class="token punctuation">,</span>
                <span class="token string">'orderDetails'</span>
                <span class="token punctuation">,</span> CallbackForResponse
                <span class="token punctuation">)</span>
                <span class="token punctuation">;</span>{" "}
                <span class="token punctuation">{"\u007D"}</span>
                {"\n"}
                <span class="token keyword">function</span>{" "}
                <span class="token function">CallbackForResponse</span>
                <span class="token punctuation">(</span>response
                <span class="token punctuation">)</span>{" "}
                <span class="token punctuation">{"\u007B"}</span> console
                <span class="token punctuation">.</span>
                <span class="token function">log</span>
                <span class="token punctuation">(</span>
                <span class="token string">"ResponseInCallback:::"</span>
                <span class="token punctuation">,</span> response
                <span class="token punctuation">)</span>
                <span class="token punctuation">;</span>{" "}
                <span class="token punctuation">{"\u007D"}</span>
                {"\n"}
                <span class="token operator">&lt;</span>
                <span class="token operator">/</span>script
                <span class="token operator">&gt;</span>
              </pre>
            </div>
            <p className="highlighter-cusm">
              spObj.Pay('encryptedData','hash','orderDetails',
              CallbackForResponse);
            </p>
            <p>
              Above line contains 3 parameters that is mandatory for transaction
              to process.
            </p>
            <div className="form-data1 mb-3">
              <pre>
                <span class="token operator">-</span> encryptedData{" "}
                <span class="token punctuation">:</span> This is the encrypted
                data created <span class="token keyword">in</span> Step
                <span class="token operator">-</span>
                <span class="token number">3.</span>
                {"\n"}
                <span class="token operator">-</span> hash{" "}
                <span class="token punctuation">:</span> This is the HASH data
                created <span class="token keyword">in</span> Step
                <span class="token operator">-</span>
                <span class="token number">4.</span>
                {"\n"}
                <span class="token operator">-</span> orderDetails{" "}
                <span class="token punctuation">:</span> This is the
                orderDetails data created <span class="token keyword">in</span>{" "}
                Step<span class="token operator">-</span>
                <span class="token number">2.</span>
              </pre>
            </div>
            <p className="para-blod">Step - 6</p>
            <p>Link your HTML to call JS-Checkout.</p>
            <div className="form-data mb-3">
              <pre>
                <xmp class="codespace">
                  <html>
                    <body>
                      <div>
                        <button onclick="Buy()">Buy</button>
                      </div>
                    </body>
                  </html>
                </xmp>
              </pre>
            </div>
            <p className="para-blod">Step - 7</p>
            <p>
              Capture transaction response in below CallBack function with data
              parameter : “response”
            </p>
            <div className="form-data1">
              <pre id="json">
                {" "}
                function CallbackForResponse(response) {"\u007B"}
                {"\n"}
                console.log("ResponseInCallback:::", response); {"\n"}
                {"\u007D"}
                {"\n"}
              </pre>
            </div>
            <h5>Sample transaction response</h5>
            <div className="form-data1">
              <pre>
                {"\u007B"}
                {"\n"}
                "data":"paygate|202110300010|4018|1.00|ARE|AED|2022-01-05|18:35:08.0|1042761641309790779|202200543961409|Successful|0|Successful|Y",
                {"\n"}
                "encData":"paygate|202110300010|4018|1.00|ARE|AED|2022-01-05|18:35:08.0|1042761641309790779|202200543961409|Successful|0|Successful|Y",
                {"\n"}
                "hashData":"ae62bb7c7bea52b5c1e6f2d8d4b55711ba3bf3a7a3a355704280004bcc71cb10bedf07ec6a4f26ff5345d8d60a58af82c7b4aa1f96b25e9b60782376996b1ebc"
                {"\n"}
                {"\u007D"}
              </pre>
            </div>
          </div>
          <div class="col-md-4"></div>
        </div>
      </div>
    </div>
  );
}
export default JSCheckOutInternational;
